/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable no-console */
import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import {
    Grid,
    Row,
    Column,
    Keyboard,
    Button,
    Heading,
    Form,
    FormInput,
    cls,
    HeaderCompound,
    SelectorButton
} from 'packages/components';
import { connect } from 'react-redux';
import Translator from '../../requests/apa/Translator';
import { autobind } from 'packages/core/lib';
import { PAYMENT_HUB_BIDIRECTIONAL } from '../utils/constants';
import { showModal, AAF_MODAL_SUCCESS, AAF_MODAL_HUB_SERVICE } from '../../actions/modal';
import { apiPaywayConfirm, registerSubscription, showError, getWorkflow, setInitialFocus, onFocusMultipleElements, handleTypeModal, redirectPlayerOneClic, isModalHide } from '../utils/Utils';
import Assets from '../../requests/apa/Asset';
import Device from '../../devices/device';
import Spinner from './../../components/Spinner';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import UtilsPagos from "../../utils/payway/UtilsPagos";
import { setMetricsEvent } from '../../actions/metrics';
import Utils from 'src/utils/Utils';
import { COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO_SELECCIONADO } from '../../packages/components/lib/utils/constants';

import './_styles.scss';
interface IHubBidirectional {
    form: {
        claveServicio: string;
        serviceId: string;
    };
    errorFromBackend: string;
    valid: boolean;
    showTooltipSuccess: boolean;
    pbi: any;
    worflowstart: any;
    type: number;
    selectedPaymentMethod: string;
    isLoading: boolean;
    wfs: any;
    step: number;
    account_data: any;
    element: any;
}

class HubBidirectional extends Component<RouteComponentProps, IHubBidirectional> {
    public textNext: string = Translator.get('hubfacturafijagate_access_option_button_next', 'SIGUIENTE');
    public textCancel: string = Translator.get(
        'hubfacturafijagate_access_option_button_cancel',
        'CANCELAR'
    );
    public stepText: string = Translator.get('top_head_step_3_label', 'PASO 3 DE 3');
    public serviceSelected: string = Translator.get(
        'hubfacturafijagate_hubcorp_services_placeHolder_textfield',
        'Selecciona el servicio al que se hará el cargo'
    );
    public serviceLabel: string = Translator.get('hubfacturafijagate_hubcorp_services_placeHolder_select', 'Servicios contratados');
    public subtitleLabel: string = Translator.get('hubfacturafijagate_access_subtitle_label');
    private isValidForm: boolean;
    public keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    private from: string = '';
    constructor(props: RouteComponentProps) {
        super(props);
        const { location: { state = {} } = {} } = props || {};
        this.from = state?.from;
        this.state = {
            form: {
                claveServicio: '',
                serviceId: '',
            },
            errorFromBackend: '',
            valid: false,
            showTooltipSuccess: false,
            pbi: {},
            worflowstart: {},
            selectedPaymentMethod: '',
            isLoading: false,
            type: 0,
            wfs: {},
            step: 0,
            account_data: [],
            element: ''
        };
    }

    public componentDidMount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('keydown', this.onKeyPress, true);
        document && document.addEventListener('sn:enter-up', this.enterUpHandler, true);
        const selectedPaymentMethod = this.props.location.state.originMethod;
        const {
            location: {
                state: { type = null, pbi = false, worflowstart = false } = {},
            } = {},
        } = this.props;
        if (pbi && worflowstart && type) {
            const wfs = getWorkflow(selectedPaymentMethod, worflowstart);
            this.setState({ pbi, worflowstart, wfs, selectedPaymentMethod, type });
        }
        if (isModalHide()) {
            setInitialFocus('.aaf_form-group-input-element .aaf_focusable', false);
        }
    }

    public componentWillUnmount(): void {
        document && document.removeEventListener('keydown', this.onKeyPress, true);
        document && document.removeEventListener('sn:enter-up', this.enterUpHandler, true);
    }

    public enterUpHandler = (e: any) => {
        const el: any = e.target;
        if (el.className.includes('aaf_focusable') || el.className.includes('aaf_selector-button-document')) {
            this.setState({ element: e.target });
        }
    };

    private handleNext = (): void => {
        const {
            pbi: { groupId = '', islive = false },
            pbi,
            wfs,
        } = this.state;
        let { form: { claveServicio } } = this.state;
        if (claveServicio.length <= 1) {
            this.setState({ errorFromBackend: Translator.get('form_tooltip_empty_label_validation', 'Debes completar este campo para continuar.') });
        } else {
            claveServicio = encodeURIComponent(claveServicio);
            this.setState({ isLoading: true });
            apiPaywayConfirm({
                pbi,
                wfs,
                formParams: { claveServicio },
                showError: false,
            })
                .then((resp) => {

                    //NOTE
                    //The common ocurrence is the user only has one service,
                    //so it's not necessary to make a second request,
                    //since the charge must apply to that one and Step 1
                    // response will be returned as the one in Step 2 directly
                    if (resp && resp.response && resp.response.purchase_data) {
                        if (pbi.isSubscription) {
                            registerSubscription(resp, pbi, this.showTicket(resp, groupId, islive));
                        } else {
                            this.showTicket(resp, groupId, islive)
                        }
                    }

                    this.setState({ isLoading: false, step: +1, account_data: resp.response.account_data });
                    setInitialFocus('.aaf_app_payment-hubbidirectional-button-service');
                })
                .catch((err) => {
                    this.setState({ isLoading: false });
                    showError(err);
                });
        }
    };

    @autobind
    private showTicket(resp: any, groupId: string, islive: boolean) {
        const { showModal } = this.props;
        const { type, worflowstart: { contentInfo }, pbi, pbi: { producttype, currency, price, family, periodicity, frequency }, selectedPaymentMethod } = this.state;
        const region = DeviceStorage.getItem('region');
        const { response: { paymentMethodData: { account = '' } = {}, end_date: { day = '', month = '', year = '' } = {}, payway_token = '' } = {} } = resp || {};
        const payDate = `${day} ${Translator.get(month)} ${year}`;
        const paymentMethodLabel = account ? `${Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, '')} ${account}` : Translator.get(`ticket_subscription_${selectedPaymentMethod}_label`, '')

        const data = {
            pbi,
            total: UtilsPagos.getTotalAndPeriodicity(currency, price, periodicity),
            duration: `${Translator.get(periodicity, '')}`,
            frequency: frequency,
            days: Translator.get(`bonus_${producttype}`),
            content: Translator.get(`Ticket_Transaccion_TextoDescripcion_${producttype}`, ''),
            payment_method: paymentMethodLabel,
            img_largeSub: Assets.get(`${region}_transactional_${family}_poster`, ''),
            img_large: contentInfo?.contentImageMedium,
            providerImage: Assets.get(`transactional_${family}_logo`),
            title: contentInfo?.contentTitle || '',
            type: type,
            from: this.from
        };
        const modal = {
            modalType: AAF_MODAL_SUCCESS,
            modalProps: {
                data: handleTypeModal({ ...data, next_pay: payDate }),
                handlePlay: () => this.from ? this.handleAddOn(resp) : this.handlePlay(groupId, payway_token, islive),
                handleVCard: () => this.handleVCard(groupId)
            }
        };
        showModal(modal);
    }

    @autobind
    private handlePlay(groupId: string, payway_token: string, islive: boolean) {
        if (groupId) {
            redirectPlayerOneClic(groupId, islive = false, payway_token, () => {
                this.handleVCard(groupId);
            })
        }
    }

    @autobind
    private handleVCard(groupId: string) {
        if (groupId) {
            const { history } = this.props;
            history.replace(`/vcard/${groupId}`);
        }
    }

    @autobind
    private handleAddOn(resp: any) {
        const { history, nodes } = this.props;
        const { response: { node_id = '' } = {} } = resp || {};
        let nodeString: string = '';
        const filterNodes = nodes.filter((value: any) => value.code === 'playandgo');
        const resultChilds = filterNodes.map((res: any) => {
            const childsValue = res.childs;
            return childsValue;
        });

        for (let index = 0; index < resultChilds.length; index++) {
            const element = resultChilds[index];
            element.map((resId: any) => {
                if (resId.id === node_id) {
                    return nodeString = resId.code;
                }
            });
        }

        this.setState({ isLoading: false });
        history.replace(`/node/${nodeString ? nodeString : 'homeuser'}`);
    }

    private handleSubmit = (): void => {
        const {
            form: { serviceId },
            pbi,
            pbi: { groupId = '', oneoffertype = '', islive = false },
            wfs,
        } = this.state;

        if (serviceId) {
            this.setState({ isLoading: true });
            apiPaywayConfirm({
                pbi,
                wfs,
                formParams: { serviceId },
            })
                .then((resp) => {
                    this.setState({ isLoading: false });
                    if (pbi.isSubscription) {
                        registerSubscription(resp, pbi, this.showTicket(resp, groupId, islive));
                    } else {
                        this.showTicket(resp, groupId, islive)
                    }
                })
                .catch((err) => {
                    this.setState({ isLoading: false });
                    showError(err);
                    this.setState({ isLoading: false });
                });
        }
    };


    @autobind
    private handleChange(value: string, type: string): void {
        const { form } = this.state;
        let { errorFromBackend } = this.state;
        this.isValidForm = value !== '';
        if (value === '' || value !== '') {
            errorFromBackend = '';
        }
        this.setState({
            errorFromBackend,
            form: { ...form, [type]: value }
        } as IHubBidirectional);
    }

    private hadleCancel = (): void => {
        const { history } = this.props;
        Utils.sendMetric(this.props, COMPONENT_PLAN_SELECTOR, METODO_DE_PAGO, LABER_CANCELAR_MEDIO_DE_PAGO_SELECCIONADO);
        history.goBack();
    };

    private handleShowService = (): void => {
        const { showModal } = this.props;
        const { account_data } = this.state;
        const services = account_data && account_data.length > 0 ? account_data : [];
        const options = services.map((service: any) => { return { id: service.service_id, name: service.service_name } })
        const modal = {
            modalType: AAF_MODAL_HUB_SERVICE,
            modalProps: {
                options,
                service: (m: any) => {
                    this.handleModal(m);
                },
            },
        };
        showModal(modal);
    };

    private handleModal = (id: any): void => {
        this.setState({ form: { serviceId: id } } as IHubBidirectional);
        setInitialFocus('.aaf_app_payment-hubbidirectional-button-service');
    };

    private getServiceTypeString = (documentId: any): string => {
        const { account_data } = this.state;
        const document = account_data.find((m: any) => {
            return m.service_id === documentId;
        });
        return document ? `${document.service_name} ${document.service_id}` : '';
    }

    @autobind
    private handleBack(): void {
        const { history } = this.props;
        history.goBack();
    }

    @autobind
    private onKeyPress(e: any): void {
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        if (currentKey === 'YELLOW') {
            this.handleBack();
        }
    }

    @autobind
    private onFocus(): void {
        const { element } = this.state;
        let activeClave: boolean = false;
        let activeDocument: boolean = false;
        const numberElements = document.getElementsByClassName('aaf_focusable');
        if (numberElements.length >= 1) {
            activeClave = true;
            if (element.id === 'document') {
                activeClave = false;
                activeDocument = true;
            }
        }
        onFocusMultipleElements([{ id: 'claveServicio', activeElement: activeClave }, { id: 'document', activeElement: activeDocument }]);
    }

    public render(): JSX.Element {
        const { step, form: { serviceId }, wfs: { gatewaytext }, errorFromBackend, isLoading,
            form: { claveServicio } = {} } = this.state;
        if (isLoading) return <Spinner className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-spinner`)} loadingMessage='' />;
        return (
            <Grid className={Device.getDevice().getPlatform()}>
                <HeaderCompound
                    disabled
                    align='right'
                    onClick={this.handleBack}
                    textBack={Translator.get('top_head_option_button_back', 'REGRESAR')}
                    icon={`${Assets.get('top_head_option_back')}`}
                    onFocus={this.onFocus}
                />
                <Row>
                    <Column lg={12}>
                        <Heading size={2} className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-title`)}>
                            {this.from ? this.stepText : ''}
                        </Heading>
                    </Column>
                </Row>
                <Row>
                    <Form id="payment-hubbidirectional-form">
                        <Column
                            lg={6}
                            className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-column-keyboard`)}
                        >
                            <Keyboard id="Keyboard" onFocus={this.onFocus} />
                        </Column>
                        <Column
                            lg={6}
                            className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-column-inputs`)}
                        >
                            <Row className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-row-inputs`)}>
                                <Column lg={12}>
                                    <Heading
                                        size={1}
                                        className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-title-form`)}
                                    >
                                        {gatewaytext}
                                    </Heading>
                                </Column>
                                <Row className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-column-input`)}>
                                    <Column lg={12}>
                                        {this.subtitleLabel !== null && <label className={`${PAYMENT_HUB_BIDIRECTIONAL}-subitle-label`}>
                                            {this.subtitleLabel}
                                        </label>}
                                        <FormInput
                                            focusWhenMount
                                            id="claveServicio"
                                            type="alphanumeric"
                                            name="claveServicio"
                                            placeholder={Translator.get(
                                                'hubfacturafijagate_hubcorp_invoiceNumber_placeHolder_textfield',
                                                'Ingresa tu número de Factura Claro'
                                            )}
                                            value={claveServicio}
                                            errorFromBackend={errorFromBackend}
                                            onChange={(e) => this.handleChange(e, 'claveServicio')}
                                            onFocus={this.onFocus}
                                            /*maxLength={getNumberLength()}*/
                                        />
                                    </Column>
                                    <Column lg={12} className={`${PAYMENT_HUB_BIDIRECTIONAL}-service-space`}>
                                        {step > 0 && <label>{this.serviceSelected}</label>}
                                        {step > 0 && (
                                            <SelectorButton
                                                id='document'
                                                type='document'
                                                onClick={this.handleShowService}
                                                className={cls(
                                                    `${PAYMENT_HUB_BIDIRECTIONAL}-button-service`
                                                )}
                                                onFocus={this.onFocus}
                                            >
                                                {serviceId ? this.getServiceTypeString(serviceId) : this.serviceLabel}
                                                <i className="icon-arrow-down payment" />
                                            </SelectorButton>
                                        )}
                                    </Column>
                                </Row>
                                <Column lg={12}>
                                    <Button
                                        activate
                                        type="button"
                                        variant="primary"
                                        disabled={!this.isValidForm}
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_HUB_BIDIRECTIONAL}-button-next`
                                        )}
                                        onClick={step > 0 ? this.handleSubmit : this.handleNext}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textNext}
                                    </Button>
                                </Column>
                                <Column
                                    lg={12}
                                    className={cls(`${PAYMENT_HUB_BIDIRECTIONAL}-column-next`)}
                                >
                                    <Button
                                        activate
                                        type="button"
                                        className={cls(
                                            `focusable`,
                                            `${PAYMENT_HUB_BIDIRECTIONAL}-button-cancel`
                                        )}
                                        onClick={this.hadleCancel}
                                        block
                                        onFocus={this.onFocus}
                                    >
                                        {this.textCancel}
                                    </Button>
                                </Column>
                            </Row>
                        </Column>
                    </Form>
                </Row>
            </Grid>
        );
    }
}

const mapDispatchToProps = {
    showModal,
    setMetricsEvent
};

export default connect(null, mapDispatchToProps)(HubBidirectional);


// WEBPACK FOOTER //
// ./src/payments/HubBidirectional/index.tsx